import React from 'react';
import { styled } from '@mui/system';

const FormSection = styled('div')({
    border: `2px solid lightgray`,
    borderRadius: 30,
    display: 'flex',
    flexDirection: 'column',
    padding: 30,
    justifyContent: 'space-between',
    margin: 10,
    gap: 20,
    width: '100%',
});

export default FormSection;
